var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 4.5,
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#676A7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1769 18C9.87168 18 9.57785 17.868 9.36289 17.6317L6.32493 14.2927C5.88492 13.8091 5.89281 13.0333 6.34244 12.5601C6.79182 12.0866 7.5131 12.0956 7.95336 12.5786L10.0642 14.8988L15.9506 6.48861C16.3289 5.94828 17.0426 5.83904 17.546 6.24655C18.0486 6.65352 18.1492 7.4216 17.771 7.9622L11.087 17.5116C10.8873 17.7969 10.5819 17.9743 10.2503 17.9973C10.2259 17.9992 10.2015 18 10.1769 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/checked-checkbox.6677abea9786e1d67c2d66d7794838de.svg";
export { ForwardRef as ReactComponent };